import { Component } from '@angular/core';
import { AppInfoService } from 'src/app/shared/services/util/app-info.service';
import { ChangeSourceTypeService } from 'ag-common-svc/lib/services/change-source-type.service';
import { ChangeSourceType } from '@ag-common-lib/public-api';

@Component({
  selector: 'ag-crm-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.scss'],
})
export class MainLayoutComponent {
  constructor(
    public appInfo: AppInfoService,
    changeSourceTypeService: ChangeSourceTypeService,
  ) {
    changeSourceTypeService.setSourceType(ChangeSourceType.regularArm, true);
  }
}
